import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { FichaResponse } from 'src/app/modal/ficha/ficha-response';
import {FichaService} from 'src/app/service/ficha/ficha.service';
import { MaestraService } from 'src/app/service/maestra/maestra.service';
@Component({
  selector: 'app-ficha',
  templateUrl: './ficha.component.html',
  styleUrls: ['./ficha.component.scss']
})
export class FichaComponent implements OnInit {

  constructor(private titleService: Title,private route: ActivatedRoute,private fichaService:FichaService,private router:Router, private maestraService:MaestraService) {

    this.titleService.setTitle("FICHA");

   }
  idDocumental:String;
  fichaModal:FichaResponse;
  fichaModalRela:FichaResponse;

  flagLoading:boolean=false;
  flagReproductor:boolean=false;
  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }

  obtenerDetalleDocumental(){
    //this.flagLoading=false;
    this.flagReproductor=false;
    this.fichaModal=new FichaResponse();
    this.maestraService.loading=true;
    console.log(this.idDocumental);
    this.fichaService.obtenerDocumentalID(this.idDocumental).subscribe(data=>{
      this.fichaModal=data;
      console.log(data);
      this.flagLoading=true;
      this.maestraService.loading=false;
      if(this.fichaModal.response.list[0].temaDesc.includes("MÚSICA ANDINA, MESTIZA Y CRIOLLA EN LOS COMPOSITORES ACADÉMICOS (1900-1950)")){
        this.flagReproductor=true;
      }

    })
  }




  documentalRelacionado(){
    this.fichaModalRela=new FichaResponse();
    console.log(this.idDocumental);
    this.fichaService.documentalRelacionado(this.idDocumental).subscribe(data=>{
      this.fichaModalRela=data;
      console.log(data);
    })

  }
  abrirVisor(){    
    if(this.fichaModal.response.list[0].id_formato=="html"){
      window.open(this.fichaModal.response.list[0].urlBasic+this.fichaModal.response.list[0].directorio+this.fichaModal.response.list[0].url, "_blank");
    }
    else{
      this.router.navigate(['/visor/'+this.idDocumental]);
    }

  }
  ngOnInit(): void {

    this.route.paramMap.subscribe((params: ParamMap) => {


      this.idDocumental = params.get('idDocumental');   
      
      this.obtenerDetalleDocumental();
      this.documentalRelacionado();
     });

  }



}
